import React, { useState } from "react";
import {
  DatePicker,
  TimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { toast } from "react-toastify";
import axios from "axios";
import "./styles.scss";
import useThemeColors from "../../vehicle/ThemeColors";
import {
  WORKSHOP_ENDTIME,
  WORKSHOP_HOLIDAY,
  WORKSHOP_ID,
  WORKSHOP_STARTTIME,
} from "../../../constants";
import { useNavigate } from "react-router-dom";

interface IPROPS {
  closeModal: any;
  // refetch:any
  requestedId: any;
}

const EditServiceRequest: React.FC<IPROPS> = ({ closeModal, requestedId }) => {
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null);
  const [selectedTime, setSelectedTime] = useState<Dayjs | null>(null);
  const [textArea, setTextArea] = useState("");
  const [loader, setLoader] = useState(false);

  const fetchingTenant = window.location.hostname.split(".")[0];
  const apiPort = process.env.REACT_APP_API_PROTOCOL;
  const getWorkshopId = localStorage.getItem(WORKSHOP_ID);
  const getWorkshopHoliday = localStorage.getItem(WORKSHOP_HOLIDAY);
  const workshopStartTime = localStorage.getItem(WORKSHOP_STARTTIME);
  const workshopEndTime = localStorage.getItem(WORKSHOP_ENDTIME);
  const navigate = useNavigate();

  const shouldDisableDate = (date: Dayjs) => {
    const dayName = date.format("dddd"); // Get day name like "Sunday"
    return getWorkshopHoliday?.includes(dayName);
  };
  const [startHour, startMinute] = workshopStartTime?.split(":") || [];
  const [endHour, endMinute] = workshopEndTime?.split(":") || [];
  const now = dayjs(); // current time
  const nowPlus2Hours = now.add(2, "hour");

  const minWorkshopTime = dayjs()
    .set("hour", +startHour)
    .set("minute", +startMinute)
    .set("second", 0);
  const maxWorkshopTime = dayjs()
    .set("hour", +endHour)
    .set("minute", +endMinute)
    .set("second", 0);
  const selectedDateIsToday = selectedDate?.isSame(dayjs(), "day");

  const minTime = selectedDateIsToday
    ? dayjs.max(minWorkshopTime, nowPlus2Hours)
    : minWorkshopTime;

  const maxTime = maxWorkshopTime;

  const handleBookService = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!selectedDate || !selectedTime) {
      alert("Please select both date and time.");
      return;
    }

    setLoader(true);

    const datePart = dayjs(selectedDate).format("YYYY-MM-DD");
    const timePart = dayjs(selectedTime).format("HH:mm:ss");
    const preferredTime = dayjs(selectedTime).format("HH:mm");

    const bookingServicePayload = {
      status: "rescheduled",
      appointment_date: `${datePart} ${preferredTime}`, // new date and time in "YYYY-MM-DD HH:MM" format
      service_reply: textArea, // (optional) any note or reason for rescheduling
      user_id: getWorkshopId,
    };

    try {
      const response = await axios.post(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/workshop-booking-requests/${requestedId}/update_status/`,
        bookingServicePayload
      );

      if (response?.data) {
        toast.success(response?.data?.message);
        sessionStorage.clear();
        closeModal();
        navigate("/vehicle/service-request");
      }
    } catch (error) {
      toast.error("An error occured");
    } finally {
      setLoader(false);
    }
  };

  const { selectedButtonBackgoundColors, selectedButtonColors } =
    useThemeColors();

  const convertTo12Hour = (time24) => {
    if (!time24) return "";
    const [hour, minute] = time24.split(":");
    const h = parseInt(hour, 10);
    const suffix = h >= 12 ? "PM" : "AM";
    const hour12 = ((h + 11) % 12) + 1;
    return `${hour12}:${minute} ${suffix}`;
  };

  return (
    <div style={{ padding: "10px 20px" }} className="reschedule_service">
      <div style={{ display: "flex", justifyContent: "center" }}>
        <label style={{ fontSize: "20px", fontWeight: "600" }}>
          Reschedule Appointment
        </label>
      </div>
      <div style={{ marginTop: "20px" }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form
            onSubmit={handleBookService}
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <div style={{ display: "flex", gap: "20px", width: "100%" }}>
              <DatePicker
                label="Select Date"
                value={selectedDate}
                onChange={(newDate) => setSelectedDate(newDate)}
                minDate={dayjs()}
                shouldDisableDate={shouldDisableDate}
              />
              <TimePicker
                label="Select Time"
                value={selectedTime}
                onChange={(newTime) => setSelectedTime(newTime)}
                ampm={false}
                minTime={minTime}
                maxTime={maxTime}
              />
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
              <label style={{ fontFamily: "karbon", fontWeight: "200" }}>
                Reason
              </label>
              <textarea
                style={{ padding: "10px", borderRadius: "10px" }}
                placeholder="Enter Reason Here"
                onChange={(e) => setTextArea(e.target.value)}
                value={textArea}
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <button
                type="submit"
                disabled={loader}
                style={{
                  width: "100%",
                  padding: "10px 25px",
                  borderRadius: "20px",
                  whiteSpace: "nowrap",
                  background: selectedButtonBackgoundColors,
                  color: selectedButtonColors,
                  border: "none",
                  fontSize: "13px",
                  cursor: loader ? "not-allowed" : "pointer",
                }}
              >
                {loader ? "Rescheduling..." : "Reschedule Service"}
              </button>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};

export default EditServiceRequest;
